import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getAlarms, getAlarm, acknowledgeAlarm, resolveAlarm } from '../alarms';
import { AlarmFilters } from '../alarms/types';

export function useAlarms(filters?: AlarmFilters) {
  return useQuery({
    queryKey: ['alarms', filters],
    queryFn: () => getAlarms(filters),
    staleTime: 30000, // Consider data fresh for 30 seconds
    retry: (failureCount, error) => {
      // Only retry network errors, not 4xx errors
      if (error.status && error.status >= 400 && error.status < 500) {
        return false;
      }
      return failureCount < 3;
    },
  });
}

export function useAlarm(id: string | null) {
  return useQuery({
    queryKey: ['alarm', id],
    queryFn: () => getAlarm(id!),
    enabled: !!id, // Only run the query if id is provided
    staleTime: 30000,
  });
}

export function useAcknowledgeAlarm() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ id, username }: { id: string; username: string }) => 
      acknowledgeAlarm(id, username),
    onSuccess: () => {
      // Invalidate alarms queries to refetch data
      queryClient.invalidateQueries({ queryKey: ['alarms'] });
    },
  });
}

export function useResolveAlarm() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ id, username }: { id: string; username: string }) => 
      resolveAlarm(id, username),
    onSuccess: () => {
      // Invalidate alarms queries to refetch data
      queryClient.invalidateQueries({ queryKey: ['alarms'] });
    },
  });
}
